import React, { useState } from "react";
import { Modal } from "antd";
import styles from "./index.module.scss";
import Header from "./components/Header";
import Aside from "./components/Aside";
import { ModalProps } from "antd/es/modal";
import CourseWareViewer from "./components/CourseWareViewer";

interface PreviewFileModalProps<T> extends ModalProps {
    onCancel?: () => void; //关闭弹窗
    list: T & { fileType?: string; viewUrl?: string }[]; //列表
    title?: string; //弹窗标题
    selectedIndex: number; //选中项索引值
    asideRender: React.ReactNode; //侧边栏组件
    children?: React.ReactNode; //底部组件
}

export default function PreviewFileModal<T>({
    onCancel,
    list,
    title,
    selectedIndex,
    asideRender,
    children,
    ...props
}: PreviewFileModalProps<T>) {
    //侧边栏展开、折叠
    const [showAside, setShowAside] = useState(true);

    return (
        <Modal
            title={null}
            footer={null}
            destroyOnClose
            className={styles.root}
            closable={false}
            centered
            getContainer={false}
            {...props}>
            <Header onCancel={onCancel} title={title} />

            <div className={styles.body}>
                <Aside
                    visible={showAside}
                    onToggle={() => setShowAside(!showAside)}
                    render={asideRender}
                />

                <div className={styles.container}>
                    <div className={styles.main}>
                        <CourseWareViewer data={list[selectedIndex]} />
                    </div>

                    {children}
                </div>
            </div>
        </Modal>
    );
}
